/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PropertySharingNamespace } from './PropertySharingNamespace';
/**
 * Identifies a category of active property identifiers.
 */
export type PropertySharingIdentifierSelector = {
    /**
     * Source system, matched using the existing token normalization.
     */
    system: string;
    /**
     * Property identifiers only; portal publication IDs are not substituted.
     */
    kind: PropertySharingIdentifierSelector.kind;
    /**
     * Exact category label, or null for an unlabeled category.
     */
    label: string | null;
    /**
     * Namespace matching rule.
     */
    namespace: PropertySharingNamespace;
};
export namespace PropertySharingIdentifierSelector {
    /**
     * Property identifiers only; portal publication IDs are not substituted.
     */
    export enum kind {
        PROPERTY_NATIVE = 'property_native',
        CUSTOM = 'custom',
    }
}

